import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AppDispatch, CustomerInterface } from "src/common";

// ============ INTERFACE ============

export interface CustomerStateInterface {
  data: {
    birthDate?: string;
    age?: number;
    email?: string;
    phoneNumber?: string;
    countryCode?: string;
  }
}

// ============ INIT STATE ============

const initialState: CustomerStateInterface = {
  data: {}
};

// ========= SLICE ==========

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomer: (state: CustomerStateInterface, action: PayloadAction<CustomerInterface>) => {
      state.data = {
        ...state.data,
        ...action.payload
      };
    },
  }
})

export const { setCustomer } = customerSlice.actions;

export default customerSlice.reducer;

export const saveCustomer = (data: CustomerInterface) => (dispatch: AppDispatch) => {
  const payload = { ...data };
  delete (payload).countryCode;
  // ApiService.consent(payload).subscribe({
  //   next: () => {

  //   },
  //   error: () => {
  //     console.log('Error while saving customer consent')
  //   },
  // });
  // ApiService.nassim(payload).subscribe({
  //   next: () => {

  //   },
  //   error: () => {
  //     console.log('Error while saving customer nassim')
  //   },
  // });
  dispatch(setCustomer(data));
};
